import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommercePublicKeyAction from '../actions/ecommerce-public-key.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommercePublicKey} from "../actions";
import {EcommercePaymentsService} from "../../websites/website/ecommerce/ecommerce-payments.service";

@Injectable()
export class EcommercePublicKeyEffect {

  loadEcommercePublicKey = createEffect(() => this._actions$.pipe(
    ofType(EcommercePublicKeyAction.LOAD_ECOMMERCE_PUBLIC_KEY),
    mergeMap((action: LoadEcommercePublicKey) => {
      const {websiteId} = action.payload;
      return this._commercePaymentsService.getPublicKey(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data) {
              return new EcommercePublicKeyAction.LoadEcommercePublicKeySuccess({
                data: response?.data,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommercePublicKeyAction.LoadEcommercePublicKeyFail({websiteId});
          })
        );
    })
  ));



  constructor(
    private _actions$: Actions,
    private _commercePaymentsService: EcommercePaymentsService
  ) {
  }

}
